
 import axios from "axios";
import { useContext } from "react";
import useTenant from "../../../hooks/useTenant";
import { ServerSideTypes } from "../../common/OperationCommonTypes";
import { DamageTypes } from "../Types";

const DamageService = {
  get: {
    
    getAll:(tenant:string,data: DamageTypes.FilterDamage,serverParams: ServerSideTypes.IParams)=>{
      let carClass = data.carClass;
      let partId =data.part?.split("-")[0];
      let positionId = data.part?.split("-")[1];
      let winity  =data.winity;
          return  axios.get<ServerSideTypes.IResult<DamageTypes.Damage>>('masterdatadamage/price/filteredprices', { params: {tenant,carClass,winity,partId,positionId, ...serverParams} }).then(
            response => response.data,
            )
          },

        allClass:(tenantValue:string)=>{
                 return axios.get("masterdatadamage/price/carclasses",{ params:{tenant: tenantValue} }).then( response =>response.data) 
                },
        
         allPart:(tenantValue:string)=>{
         return   axios.get("masterdatadamage/partposition/bytenant",{ params:{tenant: tenantValue} }
             ).then(response =>response.data) 

     },

    allWinityCodes:(tenantValue:any)=>{
         return  axios.get("/masterdatadamage/price/winitycodes",{ params:{tenant: tenantValue} }
             ).then(response =>response.data);
     },
     downloadTemplate:(tenantValue:any)=>{
      return axios.get("/masterdatadamage/price/downloadtemplate",{params:{tenant:tenantValue},responseType:"arraybuffer"})
     },
     exportExel:(data: DamageTypes.FilterDamage,tenantValue:any)=>{
      let carClass = data?.carClass;
      let partId =data.part?.split("-")[0];
      let positionId = data.part?.split("-")[1];
      let winity  =data?.winity;
      return axios.get('/masterdatadamage/price/exportexcel', { params: {tenant: tenantValue,carClass,winity,partId,positionId},responseType:"arraybuffer"})
     },

     
  },
  put:{
    edit:(data:DamageTypes.Edit)=>{
      return  axios.put('/masterdatadamage/price/updateprice',data).then(response => response.data);
      },
      uploadTemplate:(fileName: FormData,tenantValue:any)=>{
        return axios.put('/masterdatadamage/price/addprices',fileName,{params:{tenant:tenantValue}})
      },
  },
  create:{
    createDamage:(data:DamageTypes.Create,tenantValue:any)=>{ 
      let createDamage ={ 
       substitionPrice : data.substitionPrice,
       partId :data.part?.split("-")[0],
       positionId : data.part?.split("-")[1],
       lightPrice : data.lightPrice,
       mediumPrice : data.mediumPrice,
       heavyPrice : data.heavyPrice,
       carClass : data.carClass,
       paintExtraTime: data.paintExtraTime,
       winityCodeVehicle: data.winityCodeVehicle,
       winityCodeIndustrial: data.winityCodeIndustrial,
       figureCode: data.figureCode
     }
   return axios.post('/masterdatadamage/price/addprice',createDamage,{params:{tenant:tenantValue}})
    }
  },
  delete:{
    delete:(priceId: number, tenant:string)=>{
      return  axios.delete('/masterdatadamage/price/deleteprice',{ params: {priceId, tenant} }).then(response => response.data);
      }
  },

};

export default DamageService;

